import React from 'react'
import { BasicStatsItem } from '../index.styles'

const link = 'https://app.powerbi.com/view?r=eyJrIjoiZWE1ZDg3MzUtNmZjNi00MGVkLTgyZDAtZTg2ZWEyYTlmYTk5IiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'

const PsdDashboard = () => {
  return (
    <BasicStatsItem style={{
      width: '100%',
      height: '100%',
      flex: '1'
    }}>
      <iframe title="PSD iframe" src={link} />
    </BasicStatsItem>
  )
}

export default PsdDashboard
